export * from './text-input-highlight.module';
export * from './highlight-tag.interface';
